import { Card, css, format, MAGNETIC_TOKENS, toast } from '@appd/uik';
import { NodeData } from '../model';
import { BusinessJourneyStatusCard } from '../components/BusinessJourneyStatusCard';
import { TransitionKey } from '../components/TransitionKey';
import { HealthMapping } from './utils';

const { SPACING } = MAGNETIC_TOKENS;

export type Props = {
  data: NodeData;
  isRoot?: boolean;
};

export function BusinessJourneyPresentationNodeRenderer({ data, isRoot }: Props) {
  const { name, count, health, conversionRateFromPrevMilestone, isTransitionMilestone } = data;
  const { text: healthText, healthType } = HealthMapping[health];
  return (
    <Card
      title={name}
      titleTag={{ text: healthText, type: healthType }}
      className={css({ height: '100%', width: '100%' })}
      onClick={() => {
        toast({ title: 'Node Clicked', description: `Node ${name} clicked` });
      }}
      right={isTransitionMilestone && <TransitionKey />}
    >
      <div className={css({ display: 'flex', flexDirection: 'row', gap: SPACING[2] })}>
        <BusinessJourneyStatusCard className={css({ flex: '1 1 auto' })} title="Count" value={format.number(count)} />
        {!isRoot && conversionRateFromPrevMilestone !== undefined && conversionRateFromPrevMilestone !== null && (
          <BusinessJourneyStatusCard
            className={css({ flex: '1 1 auto' })}
            title="Conversion rate"
            value={format.number.percent(conversionRateFromPrevMilestone)}
          />
        )}
      </div>
    </Card>
  );
}
